import React, { useEffect, useState, useRef } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { IconButton, Box, Typography, Tooltip, Zoom, Fab } from "@mui/material";
import { Add, Remove, GetApp } from "@mui/icons-material";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import BackWithBreadcrumbAppbar from "../components/BackWithBreadcrumbAppbar";
import useUserData from "../hooks/useUserData";
import floorplan from "../Assets/floorplan.pdf";
import { useTranslation } from "react-i18next";
import LoadingPage from "./LoadingPage";
import ComingSoon from "../components/ComingSoon";

pdfjs.GlobalWorkerOptions.workerSrc =
  "https://cdn.jsdelivr.net/npm/pdfjs-dist@4.8.69/build/pdf.worker.min.mjs";

const FloorPlan = () => {
  const { t } = useTranslation();
  // const { data } = useUserData();
  // const containerRef = useRef(null);
  // const [numPages, setNumPages] = useState(null);
  // const [scale, setScale] = useState(1);
  // const [offset, setOffset] = useState({ x: 0, y: 0 });
  // const [isDragging, setIsDragging] = useState(false);
  // const [lastPosition, setLastPosition] = useState({ x: 0, y: 0 });
  // const [initialTouchDistance, setInitialTouchDistance] = useState(null);

  // // Touch handling refs
  // const touchStartRef = useRef({ x: 0, y: 0 });
  // const isPinchingRef = useRef(false);

  // const calculateDistance = (touches) => {
  //   return Math.hypot(
  //     touches[0].clientX - touches[1].clientX,
  //     touches[0].clientY - touches[1].clientY
  //   );
  // };

  // const handleTouchStart = (e) => {
  //   if (e.touches.length === 2) {
  //     isPinchingRef.current = true;
  //     setInitialTouchDistance(calculateDistance(e.touches));
  //   } else {
  //     touchStartRef.current = {
  //       x: e.touches[0].clientX,
  //       y: e.touches[0].clientY,
  //     };
  //   }
  // };

  // const handleTouchMove = (e) => {
  //   if (e.touches.length === 2 && isPinchingRef.current) {
  //     e.preventDefault();
  //     const newDistance = calculateDistance(e.touches);
  //     const newScale = (newDistance / initialTouchDistance) * scale;
  //     setScale(Math.min(Math.max(newScale, 0.5), 3));
  //   } else if (!isPinchingRef.current) {
  //     const deltaX = e.touches[0].clientX - touchStartRef.current.x;
  //     const deltaY = e.touches[0].clientY - touchStartRef.current.y;
  //     touchStartRef.current = {
  //       x: e.touches[0].clientX,
  //       y: e.touches[0].clientY,
  //     };
  //     setOffset((prev) => ({
  //       x: prev.x + deltaX,
  //       y: prev.y + deltaY,
  //     }));
  //   }
  // };

  // const handleTouchEnd = () => {
  //   isPinchingRef.current = false;
  //   setInitialTouchDistance(null);
  // };

  // const handleWheel = (e) => {
  //   if (e.ctrlKey) {
  //     e.preventDefault();
  //     setScale((prev) =>
  //       Math.min(Math.max(prev + (e.deltaY > 0 ? -0.1 : 0.1), 0.5), 3)
  //     );
  //   }
  // };

  // const handleZoomIn = () => setScale((prev) => Math.min(prev + 0.2, 3));
  // const handleZoomOut = () => setScale((prev) => Math.max(prev - 0.2, 0.5));

  // const handleDownloadPDF = async () => {
  //   try {
  //     const link = document.createElement("a");
  //     link.href = floorplan;
  //     link.download = "floorPlan_OmanWaterWeek_2025.pdf";
  //     link.click();
  //   } catch (error) {
  //     console.error("Error downloading PDF:", error);
  //   }
  // };

  // // Prevent default touch behaviors
  // useEffect(() => {
  //   const preventDefault = (e) => e.preventDefault();
  //   const container = containerRef.current;

  //   container.addEventListener("touchmove", preventDefault, { passive: false });
  //   return () => container.removeEventListener("touchmove", preventDefault);
  // }, []);

  return (
    <>
      <BackWithBreadcrumbAppbar
        links={[{ label: t("dashboard"), href: "/" }]}
        currentPage={t("floorPlan")}
      />

      <Box
        sx={{
          p: 3,
          height: "calc(100vh - 128px)",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography variant="h4" align="center" gutterBottom>
          {t("floorPlanTitle")}
        </Typography>
        <ComingSoon />
        {/* <Box
          ref={containerRef}
          sx={{
            flex: 1,
            position: 'relative',
            overflow: 'hidden',
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 2,
            bgcolor: 'background.paper',
            touchAction: 'none'
          }}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
          onWheel={handleWheel}
        >
          <Box
            sx={{
              transform: `translate(${offset.x}px, ${offset.y}px) scale(${scale})`,
              transformOrigin: '0 0',
              transition: 'transform 0.15s cubic-bezier(0.4, 0, 0.2, 1)',
              width: '100%',
              height: '100%'
            }}
          >
            <Document
              file={floorplan}
              onLoadSuccess={({ numPages }) => setNumPages(numPages)}
              loading={<LoadingPage />}
              error={
                <Box sx={{ 
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <Typography color="error">{t("floorPlanNotReady")}</Typography>
                </Box>
              }
            >
              {Array.from({ length: numPages }, (_, i) => (
                <Page 
                  key={`page_${i + 1}`}
                  pageNumber={i + 1}
                  width={containerRef.current?.offsetWidth}
                />
              ))}
            </Document>
          </Box>

          <Box
            sx={{
              position: 'absolute',
              bottom: 16,
              left: '50%',
              transform: 'translateX(-50%)',
              display: 'flex',
              gap: 1,
              bgcolor: 'background.paper',
              borderRadius: 4,
              boxShadow: 3,
              p: 1
            }}
          >
            <Tooltip title={t('zoomOut')}>
              <IconButton onClick={handleZoomOut}>
                <Remove />
              </IconButton>
            </Tooltip>
            
            <Typography sx={{ 
              display: 'flex',
              alignItems: 'center',
              px: 2,
              color: 'text.secondary'
            }}>
              {Math.round(scale * 100)}%
            </Typography>

            <Tooltip title={t('zoomIn')}>
              <IconButton onClick={handleZoomIn}>
                <Add />
              </IconButton>
            </Tooltip>
          </Box>

          <Zoom in>
            <Fab
              color="primary"
              onClick={handleDownloadPDF}
              sx={{
                position: 'absolute',
                bottom: 16,
                right: 16
              }}
            >
              <GetApp />
            </Fab>
          </Zoom>
        </Box>

        <Typography variant="caption" align="center" sx={{ 
          mt: 1,
          color: 'text.secondary'
        }}>
          {t('dragToPan')} | {t('pinchToZoom')}
        </Typography> */}
      </Box>
    </>
  );
};

export default FloorPlan;
